import { injectReducer } from "store/reducers";
import store from "store/store";
import Loadable from "react-loadable";
import Loading from "components/common/Loading";
import Error404 from "components/routes/NotFound";


const SignupPage = Loadable({
  loader: async () => {
    const component = import(/* webpackChunkName: 'SignupPage' */ "./container");

    return import (/* webpackChunkName: 'SignupPage' */ "./reducer")
      .then( (reducer) => injectReducer(store, { key: "signupPage", reducer: reducer.default }) )
      .then( () => component)
      .catch((e) => console.log("PAGE LOADING ERROR", e) || Error404);
  },
  loading: (props) => <div style={{ height: 488 }}><Loading {...props} /></div>,
});

export default SignupPage;
